var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasseyFerguson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 65,
    viewBox: "0 0 72 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6666 37.25H26.0166L29.6566 42.15L29.6766 42.13L33.3266 37.26H29.6766L29.6666 37.25ZM41.6866 42.14L45.3366 37.24H38.0366L41.6866 42.14ZM41.6866 29.22H52.5666L41.6866 43.81L35.7366 35.85L35.6666 35.75L29.6666 43.78L29.6466 43.8L18.7666 29.22H30.8666L29.6666 27.63L24.8466 21.18H46.6166L41.6766 27.79L40.6166 29.21H41.6766L41.6866 29.22ZM35.7366 34.11L39.3766 29.22H32.0766L35.7266 34.11H35.7366Z",
    fill: "#BD3938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasseyFerguson);
export default __webpack_public_path__ + "static/media/massey_ferguson.2e71b323b4c2a68a97da09f8f2f05aaa.svg";
export { ForwardRef as ReactComponent };